import { BREAKPOINTS } from '@client/common/utils/breakpointsLayout';

export const SLIDER_PARAMS = {
  xs: {
    slidesPerGroup: 1,
    slidesPerView: 1,
    spaceBetween: 0,
  },
  md: {
    slidesPerGroup: 2,
    slidesPerView: 2,
    spaceBetween: 0,
  },
  lg: {
    slidesPerGroup: 4,
    slidesPerView: 4,
    spaceBetween: 0,
  },
};

export const breakpoints = {
  [BREAKPOINTS.sm]: SLIDER_PARAMS.md,
  [BREAKPOINTS.md]: SLIDER_PARAMS.md,
  [BREAKPOINTS.lg]: SLIDER_PARAMS.lg,
};

export interface Props {
  deviceType: string;
}
